// 权限/配置类 sessionStorage 缓存键的版本号：
// 线上发现缓存数据错误需全量失效时，将版本号 bump（v1 -> v2）并发布即可，无需等待 TTL 自然过期
export const CACHE_VERSION = 'v1';



// WEBPACK FOOTER //
// ./src/common/cacheVersion.js